import { createTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

const PRIMARY = {
  lighter: '#80b779',
  light: '#70a06a',
  main: '#80B779',
  dark: '#50724c',
  darker: '#405b3c',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#d8d8ba',
  light: '#b9b99f',
  main: '#9a9a85',
  dark: '#7b7b6a',
  darker: '#5d5d50',
  contrastText: '#fff',
};

const TERTIARY = {
  main: '#fbf8d5',
  dark: '#dcd9ba',
  darker: '#bcbaa0',

};

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const scrollbarStyles = {
  html: {
    scrollbarWidth: 'medium',
    scrollbarColor: '#8fab8c #cecece',
  },
  body: {
    scrollbarWidth: 'medium',
    scrollbarColor: '#8fab8c #cecece',
  },
  '*': {
    scrollbarWidth: 'medium',
    scrollbarColor: '#8fab8c #cecece',
  },
  '*::-webkit-scrollbar': {
    width: '10px',
    height: '10px',
  },
  '*::-webkit-scrollbar-track': {
    background: '#cecece',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: '#8fab8c',
    borderRadius: '8px',
    border: '2px solid #cecece',
  },
  '*::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#50724c',
  },
};


export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: PRIMARY,
    secondary: SECONDARY,
    tertiary: TERTIARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    divider: alpha(GREY[500], 0.24),
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: {
      default: '#fff',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: scrollbarStyles,
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {         
        borderRadius: '4px',
      '&:hover': {
        borderRadius: '4px',
      },
      },
    },
  },
  },

 

// import { createTheme } from '@mui/material/styles';

// Colores principales
// Principal french-gray: #B7B4C5
   // complementarios: #A1A396, #B0B3A0, #C4B2C3, #C7B4BD, #CAB7B7
// Principal nyanza-green: #E2EDD0
   // complementarios: #A995C9, #B6A3D5, #CAEAD3, #CDECE4, #D1E9EE


// export const lightTheme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: {
//       main: '#76B0F1',
//     },
//     background: {
//       default: '#fff',
//     },
//   },

});
